import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { SearchAuditHistory } from '../../models/models';

@Component({
    selector: 'quoteorderline-history-grid',
    templateUrl: './quoteorderline-history-grid.component.html',
    standalone: false
})
export class QuoteOrderLineHistoryGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() quoteOrderLineID: number = 0;
    @Input() refreshDate: Date = new Date();

    @ViewChild(GridComponent, { static: false }) public uiGrid!: GridComponent;

    public auditHistoryList: SearchAuditHistory[] = [];
    public isLoading: boolean = false;
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'abbrev' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService,
        private notificationService: NotificationService, private ngZone: NgZone) {
    }

    ngOnInit() {
        //this.getAuditHistoryList();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.getAuditHistoryList();
        //console.log("ngOnChanges");
    }

    private getAuditHistoryList() {
        this.isLoading = true;
        this.auditHistoryList.length = 0;
        this.orderService.getAuditHistoryByQuoteOrderID(this.quoteOrderID).subscribe(result => {
            this.isLoading = false;
            this.auditHistoryList = result.resultCollection;
            this.setGrid();
            console.log("quoteOrderLineList:quoteOrderID", this.quoteOrderID, this.auditHistoryList.length);
        });
    }

    private setGrid() {
        this.gridData = process(this.auditHistoryList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.uiGrid == null) return;
            this.uiGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.auditHistoryList, this.gridState);
    }
}
